import React from 'react';
import styles from './TextEffectsSticker.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffectsStickerProps = TextEffectsSharedProps;

const TextEffectsSticker: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      tagProps={{
        'data-testid': TestIds.viewer.container,
      }}
      arePatternsDisabled={arePatternsDisabled}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={data => ({
          className: styles.wrapper,
          'data-text': data,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span
            className={cx(styles.text, styles.block)}
            data-testid={TestIds.viewer.text}
          >
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsSticker;
